module.exports = __webpack_public_path__ + "static/media/engagement-choose.8aa42fa0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/engagement-choose.svg
// module id = 435
// module chunks = 0